import { Component, Input } from '@angular/core';
import { NavigationService } from '../navigation.service';

@Component({
    selector: 'app-navbar-programare',
    templateUrl: './navbar-programare.component.html',
    styleUrls: ['./navbar-programare.component.scss']
})
export class NavbarProgramareComponent {
    @Input() continuaDisabled = false;
    @Input() onContinua: (() => void) | null = null;

    constructor(public navigationService: NavigationService) { }

    get currentStepIndex(): number {
        return this.navigationService.currentStepIndex;
    }

    goBack() {
        this.navigationService.goBack();
    }

    handleContinua() {
        if (this.onContinua) {
            this.onContinua();
        } else {
            this.navigationService.goNext();
        }
    }
}
